import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class PipelineStatusService {
    async getStatus(apiBaseUrl: string | undefined, pipelineId: number, runId: number) {
        const response = await getAuthenticatedFetch()(
            `${apiBaseUrl}/PipelineStatus/${pipelineId}/${runId}`
        );

        if (!response.ok) {
            throw new Error("Failed to get pipeline status");
        }

        return await response.json();
    }
}

const pipelineStatusService = new PipelineStatusService();
export default pipelineStatusService;
